<template>
  <va-stepper v-model="step" :steps="steps" color="danger" controlsHidden :navigation-disabled="true">
    <template #divider>
      <div class="divider gradient" />
    </template>

    <template v-for="step, i in steps" :key="step.label" #[`step-button-${i}`]="{ isCompleted }">
      <div class="step-button" :class="{
        'step-button--completed': isCompleted,
      }">

        <div>
          <va-icon :name="step.icon" />
          {{ step.label }}
        </div>
      </div>
    </template>

    <template #step-content-0>
      <ul>
        <li>Para iniciar, necesitaremos que instales la aplicación. Una vez instalada, abrela y continua con la
          configuración.</li>
        <li><br></li>
        <li><va-button @click="tryToInstall()">Instalar</va-button></li>
      </ul>
    </template>

    <template #step-content-1>
      <ul>
        <li>Necesitaremos acceso a la camara para escanear el codigo de activación</li>
        <li><br></li>
        <li><va-button @click="requestAccess()">Solicitar Acceso a la Camara</va-button></li>
      </ul>
    </template>
    <template #step-content-2>
      <ul>
        <li>También necesitaremos acceder a tu ubicación.</li>
        <li><br></li>
        <li><va-button @click="requestAccess()">Solicitar Acceso tu Ubicación</va-button></li>
      </ul>
    </template>
    <template #step-content-3>
      <ul>
        <li>Por último, deberas identificarte por medio de tu Avante.</li>
        <li><br></li>
        <li><va-button @click="requestAccess()">Escanear Código</va-button></li>
      </ul>
    </template>


  </va-stepper>
  <pwa-install
    iosinstallinfotext="Presiona el botón de 'Compartir/Share' y selecciona 'Agregar a Inicio/Add to Home Screen'. "
    explainer="Esta app se puede instalar de forma local y la veras como una app mas de tu galeria" :usecustom="true"
    showopen="true"></pwa-install>
</template>

<script>
import { ref } from 'vue'

import { VaIcon, VaStepper, VaButton } from 'vuestic-ui'
import { pwa } from 'platform-detect'
import '@pwabuilder/pwainstall'
import { ls } from 'vue-lsp'


const step = ref(0)

export default {
  name: 'ConfiguracionComponent',
  data: function () {
    return {
      step: step,
      steps: [{ label: '1. Instala la aplicación', icon: 'install_mobile' }]
    }
  },
  created() {

    this.step = pwa ? 1 : 0; //TODO: change to 1:0 for production

    if (this.step == 1) {
      this.steps = [
        { label: '1. Instala la aplicación', icon: 'install_mobile' },
        { label: '2. Permitir acceso a la camara', icon: 'photo_camera' },
        { label: '3. Permitir accesso a la ubicación', icon: 'location_on' },
        { label: '4. Escanear QR', icon: 'qr_code_2' },
      ]

      if (ls.get('permissionsIndexAllowed')) {
        this.step = ls.get('permissionsIndexAllowed');
      }
    }


  },
  components: {
    VaIcon, VaStepper, VaButton
  },
  methods: {
    requestAccess() {


      switch (this.step) {
        case 0:
          this.tryToInstall();
          break;
        case 1:
          this.requestCameraPermission();
          break;
        case 2:
          this.requestLocationPermission();
          break;
        case 3:
          this.openScanner();
          break;
      }
    },
    async requestCameraPermission() {

      var _this = this;
      navigator.mediaDevices.getUserMedia({ video: true }).then(function (mediaStream) {

        mediaStream.getTracks().forEach(function (track) {

          track.stop();
          _this.step = 2;

        });


        /* usar el flujo de datos */
      }).catch(function (err) {
        console.log(err);
        /* manejar el error */
      });

    },

    async tryToInstall() {

      document.getElementsByTagName('pwa-install')[0].openPrompt();

      this.step=1; //uncomment for production


    },
    async requestLocationPermission() {

      var _this = this;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function () {

          _this.step = 3;

          ls.set('permissionsIndexAllowed', 3);

        }, function () {


        });
      } else {
        // I believe it may also mean geolocation isn't supported
        alert('Geolocation denied');
      }
    },
    openScanner() {
      this.$router.replace('scan');
    }
  }
}
</script>


<style scoped>
.va-stepper {
  width: 100%;
}

.gradient {
  background:
    linear-gradient(90deg,
      rgb(144, 144, 145) 0%,
      rgb(253, 29, 29) 50%,
      rgb(241, 170, 48) 100%);
}

.divider {
  flex-grow: 1;
  margin: 0 1rem;
  height: 2px;
  width: 2rem;
  border-radius: 1rem;
}

.step-button {
  display: flex;
  gap: 1rem;
  color: rgb(134, 134, 134);
  cursor: pointer;
  padding: 1rem;
  transition: all 0.2s;
  width: 100%;
}

.step-button--completed {
  color: rgb(55, 151, 0);
}
</style>